/* jshint esversion: 6 */
import React from 'react';
import SocialPanelModule from 'app/mixins/SocialPanelModule.js';
import { Link } from 'react-router-dom';

class GMBOptions extends React.Component {
    render() {
        let currentPanel = null,
            optionFields = null,
            thumbFields = null,
            visibleSettings = null,
            postTitle = (parseInt(this.props.getParamValue('postTitle'), 10)) ? true : false,
            postBody = (parseInt(this.props.getParamValue('postBody'), 10)) ? true : false,
            postUrl = (parseInt(this.props.getParamValue('postUrl'), 10)) ? true : false,
            prefixSpace = (parseInt(this.props.getParamValue('prefixSpace'), 10)) ? true : false,
            postfixSpace = (parseInt(this.props.getParamValue('postfixSpace'), 10)) ? true : false,
            postImages = (parseInt(this.props.getParamValue('postImages'), 10)) ? true : false,
            includeSummaryTitle = (parseInt(this.props.getParamValue('includeSummaryTitle'), 10)) ? true : false,
            includeSummaryBody = (parseInt(this.props.getParamValue('includeSummaryBody'), 10)) ? true : false,
            constants = this.props.app.config.constants,
            actionOptions = [
                { value: constants.ACTION_LEARNMORE, label: 'Learn more' },
                { value: constants.ACTION_SIGNUP, label: 'Sign up' },
                { value: constants.ACTION_SHOP, label: 'Buy' },
                { value: constants.ACTION_ORDER, label: 'Order online' },
                { value: constants.ACTION_BOOK, label: 'Book' }
            ],
            postStyles = [
                { value: constants.POST_SHARED, label: 'Shared Link' },
                { value: constants.POST_TEXT, label: 'Status Update' }
            ];

        if (this.props.activePanel !== 'advanced') {
            if (this.props.hasInputOverrides) {
                if (this.props.user.detail.routeViewType === this.props.app.config.constants.ROUTE_VIEW_SIMPLE) {
                    visibleSettings = this.props.generateInputOverrideLink();
                } else {
                    visibleSettings = (
                        <div>
                            {this.props.generateInputOverrideWarning()}
                            {this.props.getPostActions(actionOptions)}
                        </div>
                    )
                }
            } else {
                visibleSettings = (
                    <div>
                        {this.props.getPostActions(actionOptions)}
                    </div>
                );
            }

            currentPanel = (
                <div>
                    {visibleSettings}
                    {this.props.getPrefixText(prefixSpace)}
                    {this.props.getPostfixText(postfixSpace)}
                    {this.props.getActiveToggle()}
                    {this.props.getDeleteButton()}
                </div>
            );
        }

        return this.props.getPanelOutput(currentPanel);
    }

};

export default SocialPanelModule(GMBOptions);
